import React from 'react';
import PropTypes from 'prop-types';

import ListItem from 'components/KJRN/KListItem';
import PanelTable from './panels/PanelTable';
import { TABLE, HTML } from '../constants/DataTypes';

const DetailListItem = ({
  type,
  value,
  label,
  href,
  ID,
}) => (type === TABLE
  ?
    <PanelTable dataSource={value} />
  :
    <ListItem
      style={{
          padding: 12,
          overflow: 'auto',
        }}
      innerDivStyle={{ padding: 0 }}
      disabled={!href}
        /* eslint react/no-danger: 0 */
      primaryText={type === HTML ? <div dangerouslySetInnerHTML={{ __html: value }} /> : value}
      secondaryText={label}
      data-cy={ID}
    />);

DetailListItem.propTypes = {
  type: PropTypes.string,
  href: PropTypes.string,
  ID: PropTypes.string,
  label: PropTypes.node,
  value: PropTypes.oneOfType([PropTypes.node, PropTypes.array]),
};

export default DetailListItem;



// WEBPACK FOOTER //
// ./src/components/DetailListItem.js